<template>
  <vi-alert :class="name" type="info" show-icon show-border :closable="false">
    <div slot="title" :class="`${name}__title`">
      <span>{{ $t('module_adgroup_targeting_limitation_title') }}</span>
      <vi-learn-more content-type="HEC_LIMITATION" />
    </div>
    <template slot="description">
      <vi-collapse-transition>
        <ul v-if="unfold" :class="`${name}__alertInfo`">
          <li v-for="(item, index) in alertInfo" :key="index">
            {{ item }}
          </li>
        </ul>
      </vi-collapse-transition>
      <show-more-options
        :show-text="$t('module_transaction_view_detail')"
        :hide-text="$t('module_transaction_view_detail')"
        :class="`${name}__showMore`"
        @expand="onChangeFoldStatus"
      />
    </template>
  </vi-alert>
</template>
<script>
import { defineComponent, ref, computed } from '@vue/composition-api';
import ViLearnMore from '@/components/common/learn-more/index.vue';
import ShowMoreOptions from '@/components/common/show-more-options/index.vue';
import { i18n } from '@/i18n';

const name = 'ttam-hec-limitation-alert';

export default defineComponent({
  name,
  components: {
    ShowMoreOptions,
    ViLearnMore,
  },
  props: {
    isShowAdultAge: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const unfold = ref(false);
    function onChangeFoldStatus() {
      unfold.value = !unfold.value;
    }

    const alertInfo = computed(() => [
      i18n.t(
        props.isShowAdultAge
          ? 'module_adgroup_targeting_limitation_item_one'
          : 'module_adgroup_targeting_limitation_item_psa',
      ),
      i18n.t('module_adgroup_targeting_limitation_item_two'),
      i18n.t('module_adgroup_targeting_limitation_item_three'),
      i18n.t('module_adgroup_targeting_limitation_item_four'),
      i18n.t('module_adgroup_targeting_limitation_item_five'),
    ]);

    return {
      name,
      unfold,
      onChangeFoldStatus,
      alertInfo,
    };
  },
});
</script>
<style lang="scss">
.ttam-hec-limitation-alert {
  margin-bottom: 32px !important;
  position: relative;
  padding: 6px 16px !important;
  &__showMore {
    margin-top: 4px;
    line-height: 20px;
    height: 20px;
    overflow: hidden;
  }
  &__title {
    font-weight: $font-weight-medium;
    line-height: 22px;
    :global {
      .learn-more {
        font-size: 14px;
      }
    }
  }
  &__alertInfo {
    padding-left: 12px;
    > li {
      font-size: 14px;
      font-weight: $font-weight-medium;
      line-height: 22px;
      color: $--color-group3-0;
      list-style: disc;
    }
  }
  .ttam-a-link__link {
    font-size: 14px;
  }
  .vi-alert__icon {
    position: relative;
    top: 2px;
  }
}
</style>
